import { render, staticRenderFns } from "./OngoingReinvestments.vue?vue&type=template&id=75e83ec0&scoped=true"
import script from "./OngoingReinvestments.vue?vue&type=script&lang=js"
export * from "./OngoingReinvestments.vue?vue&type=script&lang=js"
import style0 from "./OngoingReinvestments.vue?vue&type=style&index=0&id=75e83ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e83ec0",
  null
  
)

export default component.exports